import { render, staticRenderFns } from "./CoursewareCallToActionBox.vue?vue&type=template&id=0b33a315&"
import script from "./CoursewareCallToActionBox.vue?vue&type=script&lang=js&"
export * from "./CoursewareCallToActionBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports